import pckg from '../../package.json';
import { IUrlConfig } from './types';

export const getUrlConfig = (BASE_URL: string): IUrlConfig => {
  const baseUrl = import.meta.env?.VITE_BASE_URL ?? BASE_URL;

  return {
    BASE_URL: baseUrl,
    APP_VERSIONS_URL: `${baseUrl}/manageAppVersions`,
    CLIENT_URL: `${baseUrl}/v${pckg['api-version']}-client`,
    CLIENT_APP_URL: `${baseUrl}/v${pckg['api-version']}-clientsApp`,
    SPECIALIST_URL: `${baseUrl}/v${pckg['api-version']}-specialist`,
    SPECIALIST_APP_URL: `${baseUrl}/v${pckg['api-version']}-specialistApp`,
    CONSULTATION_URL: `${baseUrl}/v${pckg['api-version']}-consultation`,
    CONSULTATION_APP_URL: `${baseUrl}/v${pckg['api-version']}-consultationsApp`,
    ONBOARDING_URL: `${baseUrl}/v${pckg['api-version']}-onboarding`,
    DOCUMENTS_APP_URL: `${baseUrl}/v${pckg['api-version']}-documentsApp`,
    CONTRACT_SPECIALIST_CLIENT_APP_URL: `${baseUrl}/v${pckg['api-version']}-contractSpecialistClientApp`,
    LANGUAGES_URL: `${baseUrl}/v${pckg['api-version']}-languages`,
    COUNTRIES_URL: `${baseUrl}/v${pckg['api-version']}-countries`,
    ADMIN_URL: `${baseUrl}/v${pckg['api-version']}-admin`,
    IMAGE_URL: `${baseUrl}/v${pckg['api-version']}-image`,
    PAYMENTS_URL: `${baseUrl}/v${pckg['api-version']}-stripePayments`,
    INTERCOM_URL: `${baseUrl}/v${pckg['api-version']}-intercom`,
    BOOKING_URL: `${baseUrl}/v${pckg['api-version']}-booking`,
    AGORA_URL: `${baseUrl}/v${pckg['api-version']}-agora`,
    EMAIL_URL: `${baseUrl}/v${pckg['api-version']}-emailSystem`,
    GLOBAL_VARIABLES_URL: `${baseUrl}/v${pckg['api-version']}-globalVariables`,
    CF_NOTIFY_WHEN_JOIN_TO_CHAT: `${BASE_URL}/v${pckg['api-version']}-notifyWhenJoinToChat/psychologist/join-to-chat`,
    APP_ONBOARDING_URL: `${baseUrl}/v${pckg['api-version']}-onBoardingFlowApp`,
    CHAT_APP_API_URL: `${baseUrl}/v${pckg['api-version']}-chatApp`,
    AUTH_APP_URL: `${baseUrl}/v${pckg['api-version']}-authApp`,
    COUPONS_APP_URL: `${baseUrl}/v${pckg['api-version']}-couponsApp`,
    STRIPE_PAYMENTS_APP_URL: `${baseUrl}/v${pckg['api-version']}-stripePaymentsApp`,
    SPECIALIST_FILTERS_URL: `${baseUrl}/v${pckg['api-version']}-specialistFilters`,
    VIDEO_CALL_URL: `${baseUrl}/v${pckg['api-version']}-videoCallApp`,
    SPECIALIST_REVIEWS_URL: `${baseUrl}/v${pckg['api-version']}-specialistReviewsV2App`,
    USER_METADATA_V2_URL: `${baseUrl}/v${pckg['api-version']}-userMetadataV2App`,
    CLIENT_MINDLY_REVIEWS_URL: `${baseUrl}/v${pckg['api-version']}-clientMindlyReviewsApp`,
    WORK_TAXONOMY_APP_URL: `${baseUrl}/v${pckg['api-version']}-workTaxonomyApp`,
  };
};
